const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN as string | undefined;

export const STATE_COORDINATES: Record<string, [number, number]> = {
	AC: [-70.812, -9.974],
	AL: [-36.621, -9.571],
	AM: [-64.66, -3.119],
	AP: [-51.077, 1.41],
	BA: [-41.722, -12.579],
	CE: [-39.693, -5.498],
	DF: [-47.929, -15.78],
	ES: [-40.376, -19.183],
	GO: [-49.618, -15.827],
	MA: [-45.299, -5.659],
	MG: [-44.698, -18.512],
	MS: [-54.529, -20.769],
	MT: [-56.097, -12.644],
	PA: [-52.29, -3.416],
	PB: [-36.782, -7.239],
	PE: [-37.686, -8.814],
	PI: [-43.0, -7.718],
	PR: [-51.615, -24.891],
	RJ: [-43.172, -22.908],
	RN: [-36.528, -5.793],
	RO: [-63.034, -11.505],
	RR: [-61.399, 1.989],
	RS: [-53.063, -30.034],
	SC: [-50.515, -27.595],
	SE: [-37.073, -10.574],
	SP: [-48.548, -22.907],
	TO: [-48.333, -10.184],
};



export const hasMapboxToken = (): boolean => Boolean(MAPBOX_TOKEN);
